import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

// Components
import GatsbyHead from '../../components/layout/gatsby-head';
import Layout, { Container, TwoThirds, SideBar } from '../../components/layout';
import Hero from '../../components/hero';
import RichText from '../../components/rich-text';
import Assemblies from '../../components/assemblies';
import PageTitle from '../../components/page-title';
import { DonationBannerAssembly } from '../../components/donation-banner';
import withSplitTest from '../../components/with-split-test';

// Styles
import { ContentWithSideBar } from '../../components/styled/containers';

// Utils
import { getComponentOfType } from '../../utils/contentful-components';
import { consistentString } from '../../utils/content-formatting';
import { extractLayoutProps } from '../../utils/layout';

export const Head = ({ data }) => <GatsbyHead pageContent={data.page} />;

const ContentPage = ({ data }) => {
  const { page } = data;

  const {
    bodyCopy,
    heroContent,
    assemblies,
    title,
    contentWidth: contentWidthFromCms,
    sidebarAssemblies,
  } = page;

  const contentWidth = consistentString(contentWidthFromCms);

  const hasHero = heroContent && heroContent[0];

  const donationBannerAssembly = getComponentOfType(
    assemblies,
    'ContentfulComponentDonationBanner'
  );

  const assembliesMinusDonationBanner = assemblies
    ? assemblies.filter(
        (assembly) =>
          assembly?.internal?.type &&
          assembly.internal.type !== 'ContentfulComponentDonationBanner'
      )
    : null;

  return (
    <Layout {...extractLayoutProps(page, data.contentfulConfig)}>
      {hasHero && <Hero content={heroContent[0]} />}
      {!hasHero && (
        <PageTitle twoThirds>
          <h1>{title}</h1>
        </PageTitle>
      )}
      {(contentWidth === 'two-thirds-with-sidebar' ||
        contentWidth === 'default') && (
        <>
          <Container>
            <ContentWithSideBar>
              <TwoThirds>
                {bodyCopy ? (
                  <article>
                    <RichText richText={bodyCopy} />
                  </article>
                ) : null}

                <Assemblies
                  assemblies={assembliesMinusDonationBanner}
                  insideContainer
                  insideTwoThirds
                />
              </TwoThirds>

              {sidebarAssemblies && (
                <SideBar>
                  <Assemblies assemblies={sidebarAssemblies} />
                </SideBar>
              )}
            </ContentWithSideBar>
            <div id="hotjar-embedded-survey-original" />
          </Container>
          {donationBannerAssembly && (
            <DonationBannerAssembly contentfulData={donationBannerAssembly} />
          )}
        </>
      )}

      {contentWidth === '100%' && (
        <>
          {bodyCopy ? (
            <Container as="article">
              <TwoThirds>
                <RichText richText={bodyCopy} />
              </TwoThirds>
            </Container>
          ) : null}
          <Assemblies assemblies={assemblies} />
          <div id="hotjar-embedded-survey-original" />
        </>
      )}
    </Layout>
  );
};

ContentPage.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.object,
    contentfulConfig: PropTypes.object,
  }),
  pageContext: PropTypes.object,
};

export default withSplitTest(ContentPage);

export const pageQuery = graphql`
  query pageTemplateQuery($contentful_id: String!) {
    page: contentfulPageContent(contentful_id: { eq: $contentful_id }) {
      ...PageContentFragment
    }
    ...NavigationFragment
  }
`;
